/**
 * Enum that identifies each query
 */
export enum QueryKey {
  REGIONAL_AND_LANGUAGE_SETTINGS = 'regionalAndLanguageSettings',
  AVAILABLE_LANGUAGES = 'availableLanguages',
  SYNC_STATUS_AND_LANGUAGE_PREFERENCE = 'dirSyncStatusAndLanguagePreference',
  DATE_TIME_FORMAT = 'dateTimeFormat',
  AVAILABLE_LOCALES = 'availableLocales',
  TIMEZONE = 'timezone',
}
